import React from 'react';

import getTableCells from './getTableCells';
import getRibbon from './getRibbon';
import TableBodyRow from '../../../Table/TableBodyRow/TableBodyRow';
import TableTwiddleRow from '../../../Table/TableTwiddleRow/TableTwiddleRow';

const getTableBodyContent = (
  data,
  { index, columns, visibleColumns, rowActions, shimmer, onClickRow, ribbon, twiddle, twiddleRowAttrs },
) => {
  const tableCells = getTableCells({ columns, visibleColumns, data, shimmer, rowActions, index });
  const twiddleContent = twiddle && twiddle({ row: data, index });
  const twiddleRowProps = twiddleRowAttrs ? twiddleRowAttrs({ row: data, index }) : {};

  if (twiddleContent) {
    return (
      <TableTwiddleRow
        {...twiddleRowProps}
        key={`table-twiddle-row-${index}`}
        ribbon={getRibbon(data, ribbon)}
        trigger={<TableBodyRow ribbon={getRibbon(data, ribbon)}>{tableCells}</TableBodyRow>}
      >
        {twiddleContent}
      </TableTwiddleRow>
    );
  }

  const isLoading = shimmer && shimmer.loading;
  const onClickProps = onClickRow && !isLoading ? { onClick: () => onClickRow(data) } : {};

  return (
    <TableBodyRow key={`table-body-row-${index}`} {...onClickProps} ribbon={getRibbon(data, ribbon)}>
      {tableCells}
    </TableBodyRow>
  );
};

export default getTableBodyContent;
